export const MENU_ITEM_CUSTOMIZATION_PATH = "/menu/customize/item/:itemId/step/:stepId";
export const VIEW_CART_ITEM_CUSOTMIZATION_PATH = '/checkout/customize/item/:itemId/step/:stepId'
export const MENU_ITEM_CHOICES_CUSTOMIZATION_PATH = "/menu/customize/item/:itemId/step/:stepId/zoom/:choiceId";
export const MENU_PAGE_ROOT_PATH = "/menu"
export const CHECKOUT_PAGE_ROOT_PATH = "/checkout"
export const ITEM_DETAIL_PATH = "/menu/itemDetail/:itemId"
export const MULTICUSOMTIZATION_DELETE_PATH = '/menu/customize/delete/:itemId'